import React, { useState, useEffect }  from 'react';
import Constants from 'components/show_drawing/Constants.jsx';
import styles from 'components/show_drawing/redraw_form/_style.module.scss';
import MyEventListener from 'components/common/MyEventListener.jsx'
import { SHORT_BOOLEAN_LABEL_LIMIT } from 'components/show_drawing/redraw_form/options/renderOption.jsx';

const DimensionTextsIncludedChooser = ( { id, drawing, unit, dimensionTextschecked, setDimensionTextschecked} ) => {
  const onDimensionTextsChange = (e) => {
    setDimensionTextschecked( () => e.target.checked )
  }

  // Same half-vs-wide rule as boolean drawing-options: short translated
  // label fits in half a cell, long one (e.g. Turkish "Ölçülendirme
  // çizgileri") spans the full row.
  const label = t('models.dimension_texts');
  const widthClass = label.length <= SHORT_BOOLEAN_LABEL_LIMIT ? '' : styles.booleanGridItemWide;

  return (
    <div className={`${styles.row} ${widthClass}`}>
      <div className="input-group short-text">
        <span className={`${styles.clickable} input-group-addon input-group-addon-${window.locale} ${styles.input_add_on_for_boolean} ${styles.boolean_inline_row}`} onClick={ () => setDimensionTextschecked( (prev) => !prev) }>
          <div className={styles.div_boolean}>
            <input
              name='dimension_texts_included'
              type="checkbox"
              value="1"
              onChange={onDimensionTextsChange}
              className="drawing-option-input"
              checked={dimensionTextschecked}
              autoComplete="off"
            />
          </div>
          { label }
        </span>
      </div>
    </div>
    )
}

export default DimensionTextsIncludedChooser;
